<template>
    <div class="d-flex">
        <div>
            <pc-bs-icon
                name="person-fill"
                class="text-primary"
                style="font-size: 1.5rem" />
        </div>
        <div class="ms-2">
            <div class="fw-bold">
                {{ label }}
            </div>
            <recipient-contact-info-display
                v-bind:first="recipient.FirstName"
                v-bind:last="recipient.LastName"
                v-bind:email="email(recipient.Email)" />
            <envelope-status-text
                v-bind:text="statusDisplay"
                v-bind:status-severity="statusSeverity"
                no-text-color
                bubble-text />
        </div>
    </div>
</template>
<script>
    import recipientContactInfoDisplay from "ESignatures/recipientContactInfoDisplay.vue";
    import envelopeStatusText from "Forms/Components/Elements/envelope/envelopeStatusText.vue";
    import { ENVELOPE_RECIPIENT_CONTACT_INFO_TYPE } from "ESignatures/EditEnvelope/editEnvelopeStore";

    import { getRecipientStatusSeverity } from "ESignatures/eSignatureConstants";
    export default {
        components: {
            recipientContactInfoDisplay,
            envelopeStatusText
        },
        props: {
            recipient: { type: Object, required: true },
            recipientDefinition: { type: Object, required: true }
        },
        data() {
            return {};
        },
        computed: {
            label() {
                return this.recipientDefinition.Label;
            },
            status() {
                return this.recipient.Status;
            },
            statusDisplay() {
                const statusText = this.status.Display;
                const statusTimestamp = this.recipient.StatusTimestamp.Display;
                if (statusTimestamp) {
                    return `${statusText}: ${statusTimestamp}`;
                } else {
                    return statusText;
                }
            },
            statusCode() {
                return this.recipient.Status.Code;
            },
            statusSeverity() {
                return getRecipientStatusSeverity(this.statusCode);
            }
        },
        methods: {
            email(recipientEmail) {
                //When recipient is selected via AdminSelectorElement, email should be hidden
                if (this.recipientDefinition.ContactInfoType == ENVELOPE_RECIPIENT_CONTACT_INFO_TYPE.UserField) {
                    return "";
                }
                return recipientEmail;
            }
        }
    };
</script>
